import axios from 'axios';
import { CREATE_CART_API, SET_CART_DATA } from "./actionTypes";
import { getCartId } from "../../../utils/cart";

// Дефолтное значение apiUrl для createCartApi
export var BASKET_API_URL = '/basketapi/api/v1';
var setCartData = function setCartData(data) {
  return function (dispatch) {
    var _data$stats;
    dispatch({
      type: SET_CART_DATA,
      payload: {
        quantity: (data === null || data === void 0 ? void 0 : (_data$stats = data.stats) === null || _data$stats === void 0 ? void 0 : _data$stats.quantity) || 0,
        currentCart: data === null || data === void 0 ? void 0 : data.items
      }
    });
  };
};

/**
 * @desc: запрос кол-ва товаров в корзине
 */
var fetchCartItemsStats = function fetchCartItemsStats(_ref) {
  var region = _ref.region;
  return function (dispatch, getState) {
    var _getState, _getState$external, _getState$external$ca;
    var cartApi = (_getState = getState()) === null || _getState === void 0 ? void 0 : (_getState$external = _getState.external) === null || _getState$external === void 0 ? void 0 : (_getState$external$ca = _getState$external.cartData) === null || _getState$external$ca === void 0 ? void 0 : _getState$external$ca.cartApi;
    var cartId = getCartId();
    if (cartId && cartApi) {
      cartApi.get("Basket/".concat(cartId)).then(function (res) {
        if (region && res.data.regionPath && res.data.regionPath !== region) {
          cartApi.put("Basket/".concat(cartId, "/region"), {
            regionPath: region
          });
        }
        dispatch(setCartData(res === null || res === void 0 ? void 0 : res.data));
      });
    }
  };
};

/**
 * создание сущности для АПИ корзины
 * @param {string} apiUrl
 * @returns {AxiosInstance}
 */
var createCartApi = function createCartApi(apiUrl) {
  return function (dispatch, getState) {
    var _getState2, _getState2$external, _getState2$external$c;
    if (!apiUrl) {
      return;
    }
    var cartApi = (_getState2 = getState()) === null || _getState2 === void 0 ? void 0 : (_getState2$external = _getState2.external) === null || _getState2$external === void 0 ? void 0 : (_getState2$external$c = _getState2$external.cartData) === null || _getState2$external$c === void 0 ? void 0 : _getState2$external$c.cartApi;
    if (!cartApi) {
      cartApi = axios.create({
        baseURL: apiUrl,
        withCredentials: true
      });
      dispatch({
        type: CREATE_CART_API,
        payload: cartApi
      });
    }
  };
};
export { createCartApi, fetchCartItemsStats, setCartData };